import React, { useContext } from "react"
import "./style.scss"
import { MdMenuOpen } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { TiMessage } from "react-icons/ti";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useState } from "react";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { MyContext } from "../adminLayout";
import { MdOutlineMenu } from "react-icons/md";
import Swal from "sweetalert2";
import { processLogout } from "services/user/userService";
import { useNavigate } from "react-router-dom";
import { PacmanLoader } from "react-spinners";
import devil_cute_img from "assets/admin/devil_cute_no_bg.png"
import { FaLock } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Header = () => {
    const [isLoading, setIsLoading] = useState(false);

    const context = useContext(MyContext);
    const navigate = useNavigate()
    // const token = localStorage.getItem("token");
    const name = localStorage.getItem("name");
    const role = localStorage.getItem("role");

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleOpenMyAccDrop = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMyAccDrop = () => {
        setAnchorEl(null);
    }
    const handleLogout = async () => {
        const token = localStorage.getItem("token");
        if (token) {
          setIsLoading(true)
          try {
            await processLogout(token);
            localStorage.removeItem("token");
            localStorage.removeItem("name");
            localStorage.removeItem("role");
            localStorage.removeItem("activeTab");
            localStorage.removeItem("expirationTime");
            localStorage.removeItem("itemQuantityInCart");
    
            navigate("/login");
          } 
          catch (error) {
            console.error("Logout failed:", error);
          }
          finally {
            setIsLoading(false)
          }
        } else {
          console.error("No token found");
        }
    };

    return (
        <>
            <header>
                <div className="w-100 d-flex mt-1">
                    <div className="col-md-3 d-flex align-items-center part1">
                        <div onClick={() => context.setIsToggleSidebar(!context.isToggleSidebar)}>
                            {
                                context.isToggleSidebar===false ? <MdMenuOpen /> : <MdOutlineMenu/>
                            }
                        </div>
                        {/* <div className="searchBox d-flex align-items-center">
                            <FiSearch className="me-1"/>
                            <input type="text" placeholder="Search!!!" />
                        </div> */}
                    </div>

                    <div className="col-md-9 d-flex align-items-center justify-content-end part2">
                        {/* <TiMessage/>
                        <IoMdNotificationsOutline/> */}
                        <div className="myAccWrapper">
                            <div 
                                className="myAcc d-flex align-center-items"
                                onClick={handleOpenMyAccDrop}
                            >
                                <div className="userImg">
                                    <span className="rounded-circle">
                                        <img src={devil_cute_img} alt="" />

                                    </span>
                                </div>

                                <div className="userInfo">
                                    {role==="admin" || role==="superadmin" ? (
                                        <h6>Hi, {name}!</h6>
                                    ): (
                                        <h6>Hi, !</h6>
                                    )}
                                    <p className="mb-0">@{role}</p>
                                </div>
                            </div>

                            <Menu
                                anchorEl={anchorEl}
                                id="account-menu"
                                open={open}
                                onClose={handleCloseMyAccDrop}
                                onClick={handleCloseMyAccDrop}
                                slotProps={{
                                    paper: {
                                      elevation: 0,
                                      sx: {
                                        overflow: 'visible',
                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                          width: 32,
                                          height: 32,
                                          ml: -0.5,
                                          mr: 1,
                                        },
                                        '&::before': {
                                          content: '""',
                                          display: 'block',
                                          position: 'absolute',
                                          top: 0,
                                          right: 14,
                                          width: 10,
                                          height: 10,
                                          bgcolor: 'background.paper',
                                          transform: 'translateY(-50%) rotate(45deg)',
                                          zIndex: 0,
                                        },
                                      },
                                    },
                                  }}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                                 <Link to="/admin/my-account">
                                <MenuItem onClick={handleCloseMyAccDrop}>
                                    <ListItemIcon>
                                        <PersonAdd fontSize="small" />
                                    </ListItemIcon>
                                    Tài khoản
                                </MenuItem>
                                </Link>
                                <Link to="/admin/change-password">
                                <MenuItem>
                               
                                    <ListItemIcon>
                                        <FaLock fontSize="small" />
                                    </ListItemIcon>
                                    Đổi mật khẩu
                                    
                                </MenuItem>
                                </Link>
                               
                                <MenuItem onClick={handleLogout}>
                                    <ListItemIcon>
                                        <Logout fontSize="small" />
                                    </ListItemIcon>
                                    Đăng xuất
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                </div>
            </header>
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </>
    )
}

export default Header;